import React from 'react'
import { FaTrashAlt, FaUser, FaUserCog, FaUserPlus } from 'react-icons/fa';
import { NavLink, Outlet, useLocation } from 'react-router-dom'

export default function ProductSellersLayout() {
    
  const location = useLocation();

  return (
    <div>
        <div className='py-6  px-2 border-b border-gray-200 w-full font-inter'>
                <h1 className='text-2xl font-semibold text-[#667085]'>Products Seller</h1>
            </div>
            <div>
                <div className='flex gap-[40px] py-[20px] ps-[5px] font-inter'>
                    <NavLink
                        to="all-seller"
                        className={({ isActive }) =>
                            isActive ||
                                location.pathname === '/admin-dashboard/productsellers' ||
                                location.pathname.startsWith('/admin-dashboard/productsellers/view-product')
                                ? 'flex items-center gap-2 nav-link active-link lg:text-[14px] xl:text-[16px] font-bold text-red-600 border-b-[3px] border-red-600'
                                : 'flex items-center gap-2 nav-link lg:text-[14px] xl:text-[16px] font-bold text-gray-600'
                        }
                    >
                        <span> <FaUser size={20}/></span>All Seller
                    </NavLink>
                    <NavLink
                        to="add-seller"
                        className={({ isActive }) =>
                            isActive
                                ? 'flex items-center gap-2 nav-link active-link lg:text-[14px] xl:text-[16px] font-bold text-red-600 border-b-[3px] border-red-600'
                                : 'flex items-center gap-2 nav-link lg:text-[14px] xl:text-[16px] font-bold text-gray-600'
                        }
                    >
                        <span> <FaUserPlus size={20}/></span>Add Seller
                    </NavLink>
                    <NavLink
                        to="seller-settings"  state={{ message: "seller-settings" }}
                        className={({ isActive }) =>
                            isActive
                                ? 'flex items-center gap-2 nav-link active-link lg:text-[14px] xl:text-[16px] font-bold text-red-600 border-b-[3px] border-red-600'
                                : 'flex items-center gap-2 nav-link lg:text-[14px] xl:text-[16px] font-bold text-gray-600'
                        }
                    >
                        <span> <FaUserCog size={20}/></span>Seller Settings
                    </NavLink>
                    <NavLink
                        to="seller-trash"
                        className={({ isActive }) =>
                            isActive
                                ? 'flex items-center gap-2 nav-link active-link lg:text-[14px] xl:text-[16px] font-bold text-red-600 border-b-[3px] border-red-600'
                                : 'flex items-center gap-2 nav-link lg:text-[14px] xl:text-[16px] font-bold text-gray-600'
                        }
                    >
                       <span> <FaTrashAlt size={20}/></span>Trash
                    </NavLink>
                </div>

                <div className='py-4   w-[80vw]'>
                    <Outlet/>
                </div>
            </div>
    </div>
  )
}